import { Component } from 'react'
import { Badge, Button, Col, Container, Modal, Row, Spinner, Tab, Tabs } from 'react-bootstrap'
import { connect } from 'react-redux'
import { AmericanGreen, AntiFlashWhite, Black, Blueberry, ChineseWhite, Cultured, GoldenPoppy, GraniteGray, LightSilver, Lotion, SonicSilver, SpanishGray, White } from '../../helpers/brand_colors_helper'
import { withParams } from '../../helpers/params_helper'
import { t } from '../../helpers/translation_helper'
import Header from '../_partials/Header/_Header'
import NavBar from '../_partials/NavBar/_NavBar'

import './lesson-details.css'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { GET } from '../../api'
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper'
import GetIcon from '../../helpers/icon_helper'
import { getExtension, makeURL, trimThisDown } from '../../helpers/general_helpers'
import { faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// API URL
const apiURL = process.env.REACT_APP_API_URL

const portalURL = process.env.REACT_APP_PORTAL_URL
const imgDir = 'academic_subject_lessons'

/**
 * LessonDetails Component
 */
class LessonDetails extends Component {
    // State
    state = {
        generatingPDF: false,
        academic_subject_lesson: null,
        academic_activities: null,
        academic_lesson_attributes: null,
        academic_subject_lesson_resources: null,
        academic_subject_lesson_exams: null,
        academic_subject_sub_lessons: null,
        academic_subject_lesson_flow: null,
        subject_assigned_employees: null,
        formSections: [
            {
                uid: '1.1',
                sectionGroup: ['American', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Transdisciplinary Theme',
                enum: 'transdisciplinary_theme',
                image: require('../../assets/images/lesson/line-chart.png'),
            },
            {
                uid: '1.3',
                sectionGroup: ['American', 'General', 'UAE MOE'],
                active: false,
                completed: true,
                name: 'Central Idea',
                enum: 'central_idea',
                desc: null,
                image: require('../../assets/images/lesson/idea.png'),
            },
            {
                uid: '1.4',
                sectionGroup: ['American', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Lines of enquiry',
                enum: 'lines_of_enquiry',
                image: require('../../assets/images/lesson/inquiry.png'),
                desc: ['What lines of inquiry will define the scope of inquiry into the central idea?'],
            },
            {
                uid: '1.5',
                sectionGroup: ['American', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Approaches to learning skills',
                enum: 'approaches_to_learning',
                image: require('../../assets/images/lesson/learning-approaches.png'),
                desc: null,
            },
            {
                uid: '1.6',
                sectionGroup: ['American', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Learner Profile Attributes',
                enum: 'learner_profile',
                image: require('../../assets/images/lesson/learner-profile.png'),
                desc: ['The aim of all IB programmes is to develop internationally minded people who, recognizing their common humanity and shared guardianship of the planet, help to create a better and more peaceful world. The IB learner profile represents 10 attributes valued by IB World Schools. We believe these attributes, and others like them, can help individuals and groups become responsible members of local, national and global communities.'],
            },
            {
                uid: '1.7',
                sectionGroup: ['American', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme', 'UAE MOE'],
                active: false,
                completed: true,
                name: 'Specified Concepts',//Key Concepts
                enum: 'lesson_key_concept',
                image: require('../../assets/images/lesson/key-concepts.png'),
                desc: ['It help students to engage in abstract thinking and conceptual thinking to cope-with tricky ideas. Specified Concepts can help learners to deal with knowledge in transdisciplinary themes, which the IB intends to encourage. This kind of learning is not limited to factual concepts and content, helping students to engage with broader concepts that can motivate inquisitive, creative and critical thinking.'],
            },
            {
                uid: '1.8',
                sectionGroup: ['American', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Additional concepts',
                enum: 'additional_concept',
                image: require('../../assets/images/lesson/hyperlink.png'),
                desc: [],
            },
            {
                uid: '2.4',
                sectionGroup: ['American', 'General', 'Primary Year Programme', 'Middle Year Programme', 'UAE MOE'],//'Diploma Programme',
                active: false,
                completed: true,
                name: 'Skills',
                enum: 'learnskill',
                image: require('../../assets/images/lesson/hyperlink.png'),
                desc: [],
            },
            {
                uid: '2.5',
                sectionGroup: ['American', 'General', 'UAE MOE'],
                active: false,
                completed: true,
                name: 'Competence Goals',
                enum: 'competence_goal',
                image: require('../../assets/images/lesson/hyperlink.png'),
                desc: [],
            },
            {
                uid: '11.1',
                sectionGroup: ['American', 'General', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme', 'UAE MOE'],
                active: false,
                completed: true,
                name: 'Digital Resources',//Lesson Resources
                enum: 'external_resource',
                desc: '',
                image: require('../../assets/images/lesson/hyperlink.png'),
            },
            {
                uid: '12.1',
                sectionGroup: ['American', 'General', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Sub-Lessons',
                enum: 'sub_lesson',
                desc: ['You can add Sub Lessons. Assigned Teachers can add reflections to this Sub-Lesson.', 'Parents/Students can also add reflections when the lesson is published'],
                image: require('../../assets/images/lesson/lesson-focus.png'),
                showAddBtn: true,
                // addAction: () => this.state.modalAddResource.toggle('SubLesson', '8', '12.1', () => this.insertSubLesson(this.state.academicSubjectSubLessons.findIndex((v, i) => v.editing))),
                addAction: () => this.props.setSubLessonModal({ showModal: true, lessonData: this.props.location.state.lessonData }),
            },
            {
                uid: '12.2',
                sectionGroup: ['American', 'General', 'Primary Year Programme', 'Middle Year Programme', 'Diploma Programme'],
                active: false,
                completed: true,
                name: 'Activity',
                enum: 'activity',
                desc: ['You can generally assign Activities to this lesson.'],
                image: require('../../assets/images/lesson/lesson-focus.png'),
            },
        ],
    }

    /**
     * Component Did Mount
     */
    componentDidMount() {
        let lessonData = this.props.location.state.lessonData
        //         asl_id: lessonData.asl_id,
        // acs_id: lessonData.acs_id,
        this.getLesson()
    }

    generatePDF = (lessonData) => {
        html2canvas(document.querySelector("#lesson_pdf"), { useCORS: true, scale: 1, windowWidth: 1024 }).then(canvas => {
            let headerText = ''
            let imgWidth = 190
            let pageHeight = 297
            // Set different bottom margin based on screen resolution
            const bottomMargin = window.innerWidth < 500 ? 40 : 20; // Change to desired margin for small screens
            const imgHeight = (canvas.height * imgWidth) / canvas.width;



            const pdf = new jsPDF();

            let heightLeft = imgHeight;
            let position = 0;
            let pageNumber = 1; // Initialize page number
            let totalPages = Math.ceil(heightLeft / (pageHeight - bottomMargin)); // Calculate total pages

            console.log('imgWidth, imgHeight', canvas, imgWidth, imgHeight);


            while (heightLeft > 0) {
                // Calculate remaining page height, excluding bottom margin for content only
                const pageContentHeight = pageHeight - bottomMargin;

                // Slice the content for the current page
                const canvasPage = canvas.getContext('2d').getImageData(0, position, canvas.width, Math.min(canvas.height, pageContentHeight * (canvas.width / imgWidth)));
                const pageCanvas = document.createElement('canvas');
                pageCanvas.width = canvas.width;
                pageCanvas.height = Math.min(canvas.height - position, pageContentHeight * (canvas.width / imgWidth));
                pageCanvas.getContext('2d').putImageData(canvasPage, 0, 0);
                const imgData = pageCanvas.toDataURL('image/png');
                if (position === 0) {
                    // First page
                    pdf.addImage(imgData, 'PNG', 10, 5, imgWidth, pageCanvas.height * (imgWidth / canvas.width));
                } else {
                    // New pages
                    pdf.addPage();
                    pdf.setFontSize(10);

                    // if (headerText) {
                    //     const pageWidth = pdf.internal.pageSize.getWidth();
                    //     const textWidth = pdf.getTextWidth(headerText);
                    //     const textX = (pageWidth - textWidth) / 2;
                    //     pdf.text(headerText, textX, 15);
                    // }

                    pdf.addImage(imgData, 'PNG', 10, 5, imgWidth, pageCanvas.height * (imgWidth / canvas.width));
                }

                // Add footer with page number at the very bottom of the page
                if (totalPages > 1) {
                    const footerText = `Page ${pageNumber}`;
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const footerX = pageWidth - pdf.getTextWidth(footerText) - 10; // Align to the right with some padding
                    pdf.setFontSize(10);
                    pdf.text(footerText, footerX, pageHeight - 10); // Position at the bottom without margin
                }

                heightLeft -= pageContentHeight;
                position += pageContentHeight * (canvas.width / imgWidth);
                pageNumber++; // Increment page number
            }

            pdf.save(lessonData.asl_name + ".pdf");
            this.setState({ generatingPDF: false })

        });
    }

    getLesson = () => {
        let lessonData = this.props.location.state.lessonData
        if (this.getLessonReq) {
            this.getLessonReq.abort();
        }
        this.getLessonReq = new AbortController();
        GET('academic-subject-lessons/get-lesson-data', {
            signal: this.getLessonReq.signal,
            params: {
                asl_id: lessonData.asl_id,
                acs_id: lessonData.acs_id,
                class_id: this.props.selectedChild.class_id
            }
        })
            .then((res) => {
                this.setState({
                    academic_subject_lesson: res.data.academic_subject_lesson,
                    academic_activities: res.data.academic_activities,
                    academic_lesson_attributes: res.data.academic_lesson_attributes,
                    academic_subject_lesson_resources: res.data.academic_subject_lesson_resources.map((v) => { return { ...v, aslr_tags: JSON.parse(v.aslr_tags) } }),
                    academic_subject_lesson_exams: res.data.academic_subject_lesson_exams,
                    academic_subject_sub_lessons: res.data.academic_subject_sub_lessons,
                    academic_subject_lesson_flow: res.data.academic_subject_lesson_flow,
                    subject_assigned_employees: res.data.subject_assigned_employees,
                })
            })
    }



    renderLessonEvaluationTypes = () => {
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections } = this.state
        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type


        if (academic_subject_lesson.asl_oral == 0 && academic_subject_lesson.asl_activities == 0 && academic_subject_lesson.asl_written_work == 0 && academic_subject_lesson.asl_student_work == 0 && academic_subject_lesson.asl_dual_assessment == 0 && academic_subject_lesson.asl_self_assessment == 0 && academic_subject_lesson.asl_objectives_list == 0 && academic_subject_lesson.asl_drop_quiz == 0) {
            return null
        }


        {/* Evaluation Types */ }
        return <div className='px-3 py-2 d-flex flex-column'>
            <div style={{ fontSize: 12, fontWeight: '600' }} className='mb-1'>Evaluation Types</div>
            <div className='d-flex flex-row flex-wrap' style={{ fontSize: 12 }}>
                {(academic_subject_lesson.asl_oral == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Oral</div>
                }
                {(academic_subject_lesson.asl_activities == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Activities</div>
                }
                {(academic_subject_lesson.asl_written_work == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Written Work</div>
                }
                {(academic_subject_lesson.asl_student_work == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Student Work</div>
                }
                {(academic_subject_lesson.asl_dual_assessment == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Peer-Evaluation</div>
                }
                {(academic_subject_lesson.asl_self_assessment == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Self Assessment</div>
                }
                {(academic_subject_lesson.asl_objectives_list == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Rubrics / List</div>
                }
                {(academic_subject_lesson.asl_drop_quiz == 1) &&
                    <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>Quiz</div>
                }
            </div>
        </div>
    }
    renderLessonCentralIdea = () => {
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections } = this.state
        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type

        return ((academic_subject_lesson.asl_usefulness || academic_subject_lesson.asl_preparation || academic_subject_lesson.asl_warmup || academic_subject_lesson.asl_steps || academic_subject_lesson.asl_ending || academic_subject_lesson.asl_differentiation || academic_subject_lesson.asl_objectives_description || academic_subject_lesson.asl_homeworks || academic_subject_lesson.asl_technology)) &&
            <div className='d-flex flex-row flex-wrap pt-2 px-2'>
                {academic_subject_lesson.asl_usefulness &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{(sectionGroup == 'UAE MOE') ? t('Related Concepts') : t('Introduction / Explain it to students in brief')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_usefulness }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_usefulness} */}
                            </div>
                        </div>
                    </div>
                }

                {academic_subject_lesson.asl_preparation &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Instruction / Preparation')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_preparation }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_preparation} */}
                            </div>
                        </div>
                    </div>
                }

                {academic_subject_lesson.asl_warmup &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Guided Practice / Warm up')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_warmup }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_warmup} */}
                            </div>
                        </div>
                    </div>
                }

                {academic_subject_lesson.asl_steps &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Practice / Lesson Steps')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_steps }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_steps} */}
                            </div>
                        </div>
                    </div>
                }

                {academic_subject_lesson.asl_ending &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Closing')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_ending }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_ending} */}
                            </div>
                        </div>
                    </div>
                }

                {academic_subject_lesson.asl_differentiation &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Differentiation')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_differentiation }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_differentiation} */}
                            </div>
                        </div>
                    </div>
                }

                {academic_subject_lesson.asl_objectives_description &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Objective')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_objectives_description }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_objectives_description} */}
                            </div>
                        </div>
                    </div>
                }
                {academic_subject_lesson.asl_homeworks &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Activities')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_homeworks }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_homeworks} */}
                            </div>
                        </div>
                    </div>
                }
                {academic_subject_lesson.asl_technology &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Technology')}</div>
                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: academic_subject_lesson.asl_technology }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {academic_subject_lesson.asl_technology} */}
                            </div>
                        </div>
                    </div>
                }
            </div>

    }

    renderSimpleResources = (data_v, data_i) => {
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections, subject_assigned_employees } = this.state
        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type
        const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);
        let thisData = null
        let transdisciplinary_theme = null
        if (data_v.enum == 'transdisciplinary_theme') {
            transdisciplinary_theme = academic_subject_lesson_resources.find((v) => v.aslr_type == data_v.enum)
            thisData = academic_subject_lesson_resources.filter((v) => v.aslr_type == 'transdisciplinary_theme_focus')
        } else {
            thisData = academic_subject_lesson_resources.filter((v) => v.aslr_type == data_v.enum)
        }
        return (transdisciplinary_theme || (thisData && thisData.length > 0)) &&
            <div className='d-flex flex-row p-3'>
                {transdisciplinary_theme &&
                    <div className='d-flex flex-column justify-content-center align-items-center pe-3'>
                        <div style={{ width: 60, height: 60 }}>
                            <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_lesson_attributes/' + transdisciplinary_theme.ala_description_2} style={{ width: '80%' }} />
                        </div>
                        <div style={{ fontSize: 13 }}>{transdisciplinary_theme.aslr_title}</div>
                    </div>
                }

                <div className='d-flex flex-row flex-wrap' style={{ flex: 1, fontSize: 12 }}>
                    {transdisciplinary_theme &&
                        <div style={{ width: '100%', color: SpanishGray, fontStyle: 'italic' }} className={'pb-2 px-2'}>
                            {transdisciplinary_theme.ala_description_1}
                        </div>
                    }
                    {thisData && thisData.map((v, i) => {
                        return (['lesson_key_concept', 'user_reflection', 'action_prior_learning'].includes(data_v.enum))
                            ? <div key={i} style={{ width: '100%' }} className={'pb-2 px-2'}>
                                <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + AmericanGreen, height: '100%' }} className='px-2 py-2 d-flex flex-column'>
                                    {(v.ala_title || v.aslr_title) &&
                                        <div className='d-flex flex-row flex-wrap mb-1' style={{ fontWeight: '600', fontStyle: 'italic', color: GraniteGray }}>{v.ala_title || v.aslr_title}</div>
                                    }
                                    {v.ala_description_2 &&
                                        <div className='d-flex flex-row flex-wrap mb-2' style={{ fontStyle: 'italic', color: GraniteGray }}>{v.ala_description_2}</div>
                                    }
                                    {v.ala_description_1 &&
                                        <div className='d-flex flex-row flex-wrap mb-1' style={{ fontWeight: '600' }}>{v.ala_description_1}</div>
                                    }
                                    {v.aslr_desc &&
                                        <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: v.aslr_desc }} style={{ whiteSpace: 'pre-line' }}>
                                            {/* {v.aslr_desc} */}
                                        </div>
                                    }
                                    {v.aslr_attachment &&
                                        <div className='d-flex flex-row flex-wrap'>
                                            <div className='cursor-pointer px-2 py-1' style={{ backgroundColor: White, border: 'solid 1px ' + Blueberry, borderRadius: 8 }} onClick={() => {
                                                window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lesson_resources/' + v.aslr_attachment, '', 'width=800,height=600')
                                            }}>
                                                {t('Attachment')}
                                                <GetIcon className={'ms-1 mb-1'} icon="LuExternalLink" style={{ color: Blueberry }} />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            : <div key={i} style={{ width: '50%' }} className={'pb-2 px-2'}>
                                <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + Blueberry, height: '100%' }} className='px-2 py-2 d-flex flex-column'>
                                    <div className='d-flex flex-row flex-wrap'>{v.aslr_title}</div>
                                    {v.aslr_tags && Array.isArray(v.aslr_tags) &&
                                        <div className='d-flex flex-row flex-wrap mt-2'>
                                            {v.aslr_tags.map((v) => {
                                                if (data_v.enum == 'user_comment') {
                                                    let findUser = subject_assigned_employees.find((vv) => vv.user_id == v)
                                                    if (!findUser) {
                                                        return null
                                                    } else {
                                                        v = findUser.full_name
                                                    }
                                                }
                                                return <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>{v}</div>
                                            })}
                                        </div>
                                    }
                                </div>
                            </div>
                    })}
                </div>
            </div >
    }

    renderParentChildrenResources = (data_v, data_i) => {
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections } = this.state
        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type
        const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);
        let thisData = null
        thisData = academic_subject_lesson_resources.filter((v) => v.aslr_type == data_v.enum)
        return ((thisData && thisData.length > 0)) &&
            <div className='d-flex flex-column p-3'>
                {thisData.map((parent_v, parent_i) => {
                    if (parent_v.ala_parent_id != 0) {
                        return null
                    }

                    return (data_v.enum == 'competency_parent')
                        ? <div key={parent_i} className={'pb-2'}>
                            <div className='d-flex flex-row align-items-center mb-2' style={{ flex: 1, fontSize: 13 }}>
                                <div style={{ fontWeight: '600' }}>
                                    {parent_v.progass_code}
                                </div>
                                <div className='mx-2'>
                                    <GetIcon icon="LuChevronRight" className={'mb-1'} />
                                </div>
                                <div style={{ fontWeight: '600', color: parent_v.learnarea_color }}>
                                    {parent_v.learnarea_code}
                                </div>
                                <div className='mx-2'>
                                    <GetIcon icon="LuChevronRight" className={'mb-1'} />
                                </div>
                                <div style={{ fontWeight: '600' }}>
                                    {parent_v.lrnaspect_code}
                                </div>
                            </div>
                            <div className='d-flex flex-row flex-wrap' style={{ flex: 1, fontSize: 12 }}>
                                {academic_subject_lesson_resources.map((v, i) => {
                                    if (v.aslr_type != 'competency' || v.lrnaspect_id != parent_v.lrnaspect_id) {
                                        return null
                                    }
                                    return <div key={i} style={{ width: '100%' }} className={'pb-2 px-2'}>
                                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + Blueberry, height: '100%' }} className='px-2 py-2 d-flex flex-row flex-wrap '>
                                            <div className='me-2' style={{ fontWeight: '600' }}>{'#' + v.curriculum_ref_num}</div>
                                            <div className='d-flex flex-row flex-wrap'>
                                                {(parseInt(this.props.defaultLanguage.lang_id) == 1)
                                                    ? v.curriculum_desc || v.curriculum_code
                                                    : v.curriculum_desc2 || v.curriculum_desc || v.curriculum_code}
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                        : <div key={parent_i} className={'pb-2'}>
                            <div style={{ fontWeight: '600' }} className='d-flex flex-row flex-wrap mb-3'>
                                {parent_v.aslr_title}
                            </div>
                            <div className='d-flex flex-row flex-wrap' style={{ flex: 1, fontSize: 12 }}>
                                {thisData.map((v, i) => {
                                    if (parent_v.ala_id != v.ala_parent_id) {
                                        return null
                                    }
                                    return <div key={i} style={{ width: '50%' }} className={'pb-2 px-2'}>
                                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + Blueberry, height: '100%' }} className='px-2 py-2 d-flex flex-row flex-wrap '>
                                            {v.aslr_title}
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                })}

            </div>
    }

    renderExternalResources = (data_v, data_i) => {
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections } = this.state

        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type
        let thisData = null
        thisData = academic_subject_lesson_resources.filter((v) => v.aslr_type == data_v.enum && (v.aslr_tags).includes('public'))
        return <div className='d-flex flex-row flex-wrap p-3' style={{ fontSize: 12 }}>
            {thisData && thisData.map((v, i) => {
                return <div key={i} style={{ width: '20%', fontSize: 13 }} className={'pb-2 px-2'}>

                    <div className='d-flex flex-column p-2' style={{ borderRadius: 8, backgroundColor: Lotion, height: '100%' }}>
                        <div className='p-3 m-1' style={{ borderRadius: 8, backgroundColor: Cultured, border: 'solid 1px ' + AntiFlashWhite }}>
                            {(v.aslr_attachment)
                                ? <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lesson_resources/' + v.aslr_attachment} style={{ objectFit: 'cover', width: '100%', height: '100px', backgroundColor: White, borderRadius: '8px' }} />
                                : <img src={require('../../assets/images/' + v.aslr_url_type + '.png')} style={{ objectFit: 'cover', width: '100%', height: '100px', backgroundColor: White, borderRadius: '8px' }} />
                            }
                        </div>
                        <div className='d-flex flex-row'>
                            <div style={{ flex: 1, fontWeight: '600' }} className='d-flex flex-row flex-wrap'>{v.aslr_title}</div>
                            <div className='px-1 cursor-pointer' onClick={() => {
                                if (v.aslr_url_type == 'youtube') {
                                    window.open(makeURL(v.aslr_url), '', 'width=800,height=600')
                                } else {
                                    if (v.aslr_url) {
                                        window.open(makeURL(v.aslr_url), '_blank')
                                    } else {
                                        window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lesson_resources/' + v.aslr_attachment, '', 'width=800,height=600')
                                    }
                                }
                            }}>
                                <GetIcon icon="LuExternalLink" style={{ color: Blueberry }} />
                            </div>
                        </div>
                    </div>



                </div>
            })}
        </div>
    }

    renderAssessmentInformation = () => {
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections } = this.state
        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type

        let Formative_Assessment_1 = academic_subject_lesson_resources.find((vvv) => vvv.aslr_type == 'Formative Assessment 1')
        let Formative_Assessment_2 = academic_subject_lesson_resources.find((vvv) => vvv.aslr_type == 'Formative Assessment 2')
        let Formative_Assessment_3 = academic_subject_lesson_resources.find((vvv) => vvv.aslr_type == 'Formative Assessment 3')
        let Summative_assessment = academic_subject_lesson_resources.find((vvv) => vvv.aslr_type == 'Summative assessment')
        let Assessment_Types = academic_subject_lesson_resources.find((vvv) => vvv.aslr_type == 'Assessment Types')

        return ((Formative_Assessment_1 || Formative_Assessment_2 || Formative_Assessment_3 || Summative_assessment || Assessment_Types)) &&
            <div className='d-flex flex-row flex-wrap py-2 px-2'>

                {Assessment_Types && Array.isArray(Assessment_Types.aslr_tags) && Assessment_Types.aslr_tags.length > 0 &&
                    <div className='d-flex flex-row flex-wrap mb-2' style={{ fontSize: 12, width: '100%' }}>
                        {Assessment_Types.aslr_tags.map((v) => {
                            return <div className='me-2 mb-2 px-2 py-1' style={{ borderRadius: 5, color: White, backgroundColor: Blueberry }}>{v}</div>
                        })}
                    </div>
                }

                {Formative_Assessment_1 &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Formative Assessment 1')}</div>                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: Formative_Assessment_1.aslr_title }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {Formative_Assessment_1} */}
                            </div>
                        </div>
                    </div>
                }

                {Formative_Assessment_2 &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Formative Assessment 2')}</div>                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: Formative_Assessment_2.aslr_title }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {Formative_Assessment_2} */}
                            </div>
                        </div>
                    </div>
                }

                {Formative_Assessment_3 &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Formative Assessment 3')}</div>                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: Formative_Assessment_3.aslr_title }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {Formative_Assessment_3} */}
                            </div>
                        </div>
                    </div>
                }

                {Summative_assessment &&
                    <div style={{ width: '50%' }} className={'pb-2 px-2'}>
                        <div style={{ backgroundColor: Cultured, borderRadius: 10, borderLeft: 'solid 2px ' + GoldenPoppy, height: '100%' }} className='px-2 py-1 d-flex flex-column'>
                            <div style={{ fontWeight: '600' }}>{t('Summative Assessment')}</div>                            <div className='d-flex flex-row flex-wrap' dangerouslySetInnerHTML={{ __html: Summative_assessment.aslr_title }} style={{ whiteSpace: 'pre-line' }}>
                                {/* {Summative_assessment} */}
                            </div>
                        </div>
                    </div>
                }




            </div>

    }

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        // Language Direction
        const { lang_orientation: dir } = this.props.defaultLanguage
        let { authData } = this.props
        let { academic_subject_lesson, academic_activities, academic_lesson_attributes, academic_subject_lesson_resources, academic_subject_lesson_exams, academic_subject_sub_lessons, academic_subject_lesson_flow, formSections, generatingPDF } = this.state

        if (!academic_subject_lesson) {
            return null
        }
        const sectionGroup = academic_subject_lesson.agegroup_type

        return (
            <Container fluid>
                <div id='iedu-layout'>
                    <NavBar />
                    <div id='page-content'>
                        {/* <Header lite={true} heading={t('Lesson Details')} backBtn={true} /> */}
                        <header
                            id='iedu-header'
                            className={'pt-3 lite-header'}
                            style={{ height: '' }}>
                            <Row>
                                <Col md="auto" className='d-flex align-items-center'>
                                    <span className='header-back-btn' onClick={() => window.history.back()}>
                                        <FontAwesomeIcon icon={dir == 1 ? faArrowAltCircleRight : faArrowAltCircleLeft} color={Black} />
                                    </span>
                                    <h4 className={dir == 1 ? 'mb-0 pe-2' : 'mb-0 ps-2'}>
                                        {'Lesson'}
                                    </h4>
                                    <h5 className={dir == 1 ? 'mb-0 pe-3' : 'mb-0 ps-3'} style={{ color: SonicSilver }}>
                                        {academic_subject_lesson.asl_name}
                                    </h5>
                                </Col>
                                <Col>
                                    <div className='d-flex flex-row justify-content-end'>
                                        <Button variant='outline-danger' className='me-2' size='lg' style={{ borderRadius: 25, fontSize: 16 }} onClick={() => this.setState({ generatingPDF: true }, () => this.generatePDF(academic_subject_lesson))}>
                                            <GetIcon icon={'AiOutlineFilePdf'} className={'mb-1 me-1'} />
                                            {t('Download PDF')}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </header>
                        <div>

                            {generatingPDF &&
                                <div className='d-flex flex-column justify-content-center align-items-center m-2'>
                                    <Spinner as='span' animation='grow' size='lg' role='status' aria-hidden='true' className='mb-1' />
                                    <div style={{ fontSize: 12, fontWeight: '600' }}>{t('Generating PDF')}</div>
                                </div>
                            }


                            <div id="lesson_pdf">
                                <div style={{ backgroundColor: AntiFlashWhite, borderRadius: 20, fontSize: 13 }} className='d-flex flex-column p-2'>

                                    {/* LESSON */}
                                    <div style={{ backgroundColor: White, borderRadius: 10 }} className='d-flex flex-column p-3 mb-2'>
                                        <div style={{ backgroundColor: White, borderRadius: 10 }} className='d-flex flex-row justify-content-between'>
                                            <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                                <div style={{ width: 100, height: 100 }}>
                                                    <img src={
                                                        (academic_subject_lesson.asl_attach)
                                                            ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lessons/' + academic_subject_lesson.asl_attach
                                                            : require('../../assets/images/noimage.png')
                                                    } style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                                                </div>
                                                <div className='d-flex flex-column ps-2' style={{ height: '100%' }}>
                                                    <div style={{ color: GraniteGray, fontSize: 12 }}>{academic_subject_lesson.asl_code}</div>
                                                    <div className='my-1' style={{ fontSize: 15, fontWeight: '600' }}>
                                                        {academic_subject_lesson.asl_link &&
                                                            <Button variant='info' size='sm' style={{ color: White }} className='me-2' title={academic_subject_lesson.asl_link} onClick={() => window.open(makeURL(academic_subject_lesson.asl_link), '', 'width=800,height=600')}>
                                                                <GetIcon icon="LuExternalLink" className={'me-1'} />
                                                                Open
                                                            </Button>
                                                        }
                                                        {academic_subject_lesson.asl_name}
                                                    </div>
                                                    <div className='d-flex flex-row' style={{ fontSize: 13 }}>
                                                        {academic_subject_lesson.asl_type1 &&
                                                            <Badge bg='success' className='me-1'>{academic_subject_lesson.asl_type1}</Badge>
                                                        }
                                                        {academic_subject_lesson.asl_type2 &&
                                                            <Badge bg='success' className='me-1'>{academic_subject_lesson.asl_type2}</Badge>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column align-items-end' style={{ flex: 1 }}>
                                                <div className='d-flex flex-row'>
                                                    <div className='me-1'>Periods:</div>
                                                    <div style={{ fontWeight: '600' }}>{academic_subject_lesson.asl_period}</div>
                                                </div>
                                                <div className='d-flex flex-row'>
                                                    <div className='me-1'>Theme:</div>
                                                    <div style={{ fontWeight: '600' }}>{academic_subject_lesson.asl_theme}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex flex-row flex-wrap'>{academic_subject_lesson.asl_notes1}</div>
                                    </div>

                                    {generatingPDF
                                        //FOR PDF START
                                        ? <div className='d-flex flex-column mt-2'>
                                            {formSections.map((data_v, data_i) => {
                                                // || data_v.sectionGroup.includes(sectionGroup)
                                                if (!data_v.sectionGroup.includes(sectionGroup)) {
                                                    return null
                                                }

                                                if (['external_resource', 'Assessment_Information', 'exams', 'sub_lesson', 'activity'].includes(data_v.enum)) {
                                                    return <div key={data_i} style={{ backgroundColor: White, borderRadius: 10 }} className=' mb-2'>
                                                        <div className='d-flex flex-row px-3 py-2' style={{ borderBottom: 'solid 1px ' + LightSilver, fontSize: 16 }}>{data_v.name}</div>
                                                        {/* DESC */}
                                                        <div className='d-flex flex-column'>
                                                            {data_v.desc && data_v.desc.map((vvv) => {
                                                                return <div className='px-2 py-1' style={{ fontSize: 14, color: GraniteGray, fontStyle: 'italic' }}>{vvv}</div>
                                                            })}
                                                        </div>
                                                        {data_v.enum == 'external_resource' && this.renderExternalResources(data_v, data_i)}
                                                        {data_v.enum == 'Assessment_Information' && this.renderAssessmentInformation(data_v, data_i)}
                                                        {data_v.enum == 'activity' && <RenderActivities authData={authData} data_v={data_v} academic_activities={academic_activities} />}
                                                        {data_v.enum == 'sub_lesson' && <RenderSubLesson authData={authData} data_v={data_v} academic_subject_sub_lessons={academic_subject_sub_lessons} academic_subject_lesson_resources={academic_subject_lesson_resources} />}
                                                        {data_v.enum == 'exams' && <RenderExam authData={authData} data_v={data_v} academic_subject_lesson_exams={academic_subject_lesson_exams} />}

                                                    </div>
                                                } else {
                                                    return <div key={data_i} style={{ backgroundColor: White, borderRadius: 10 }} className=' mb-2'>
                                                        {(data_v.enum != 'transdisciplinary_theme') &&
                                                            <div className='d-flex flex-row px-3 py-2' style={{ borderBottom: 'solid 1px ' + LightSilver, fontSize: 16 }}>{data_v.name}</div>
                                                        }
                                                        {/* DESC */}
                                                        <div className='d-flex flex-column'>
                                                            {data_v.desc && data_v.desc.map((vvv) => {
                                                                return <div className='px-2 py-1' style={{ fontSize: 14, color: SpanishGray, fontStyle: 'italic' }}>{vvv}</div>
                                                            })}
                                                            {data_v.enum == 'central_idea' &&
                                                                <div className='px-2 py-1'>
                                                                    <div style={{ fontSize: 14, fontWeight: '600' }} className='mb-1'>
                                                                        {(sectionGroup == 'UAE MOE' || sectionGroup == 'General') ? t('Strategies') : t('Central Idea')}
                                                                    </div>
                                                                    <div style={{ fontSize: 14, color: SpanishGray, fontStyle: 'italic', whiteSpace: 'pre-line' }}>{academic_subject_lesson.asl_notes1}</div>
                                                                </div>
                                                            }
                                                        </div>

                                                        {
                                                            (['lines_of_enquiry', 'additional_concept', 'learnskill', 'lesson_key_concept', 'action_prior_learning', 'keyvocab', 'teaching_resource', 'prior_learning', 'connection_transdisciplinary_past', 'question_teacher', 'question_student', 'user_comment', 'service_learning_opportunity', 'service_learning_outcome', 'ongoing_reflection', 'user_reflection'].includes(data_v.enum)) &&
                                                            this.renderSimpleResources(data_v, data_i)
                                                        }

                                                        {
                                                            (['approaches_to_learning', 'learner_profile', 'competency_parent'].includes(data_v.enum)) &&
                                                            this.renderParentChildrenResources(data_v, data_i)
                                                        }

                                                        {/* {(data_v.enum == 'central_idea') &&
                                                            this.renderLessonCentralIdea()
                                                        } */}
                                                        {/* {(data_v.enum == 'central_idea') &&
                                                            this.renderLessonEvaluationTypes()
                                                        } */}

                                                    </div>
                                                }
                                            })}
                                        </div>
                                        //FOR PDF END
                                        // FOR VIEW START
                                        : <Tabs defaultActiveKey="lesson">
                                            <Tab eventKey="lesson" title="Lesson">
                                                <div className='d-flex flex-column mt-2'>
                                                    {formSections.map((data_v, data_i) => {
                                                        if (!data_v.sectionGroup.includes(sectionGroup) || ['external_resource', 'Assessment_Information', 'exams', 'sub_lesson', 'activity'].includes(data_v.enum)) {
                                                            return null
                                                        }

                                                        return <div key={data_i} style={{ backgroundColor: White, borderRadius: 10 }} className=' mb-2'>
                                                            {(data_v.enum != 'transdisciplinary_theme') &&
                                                                <div className='d-flex flex-row px-3 py-2' style={{ borderBottom: 'solid 1px ' + LightSilver, fontSize: 16 }}>{data_v.name}</div>
                                                            }
                                                            {/* DESC */}
                                                            <div className='d-flex flex-column'>
                                                                {data_v.desc && data_v.desc.map((vvv) => {
                                                                    return <div className='px-2 py-1' style={{ fontSize: 14, color: SpanishGray, fontStyle: 'italic' }}>{vvv}</div>
                                                                })}
                                                                {data_v.enum == 'central_idea' &&
                                                                    <div className='px-2 py-1'>
                                                                        <div style={{ fontSize: 14, fontWeight: '600' }} className='mb-1'>
                                                                            {(sectionGroup == 'UAE MOE' || sectionGroup == 'General') ? t('Strategies') : t('Central Idea')}
                                                                        </div>
                                                                        <div style={{ fontSize: 14, color: SpanishGray, fontStyle: 'italic', whiteSpace: 'pre-line' }}>{academic_subject_lesson.asl_notes1}</div>
                                                                    </div>
                                                                }
                                                            </div>

                                                            {
                                                                (['lines_of_enquiry', 'additional_concept', 'learnskill', 'lesson_key_concept', 'action_prior_learning', 'keyvocab', 'teaching_resource', 'prior_learning', 'connection_transdisciplinary_past', 'question_teacher', 'question_student', 'user_comment', 'service_learning_opportunity', 'service_learning_outcome', 'ongoing_reflection', 'user_reflection'].includes(data_v.enum)) &&
                                                                this.renderSimpleResources(data_v, data_i)
                                                            }

                                                            {
                                                                (['approaches_to_learning', 'learner_profile', 'competency_parent'].includes(data_v.enum)) &&
                                                                this.renderParentChildrenResources(data_v, data_i)
                                                            }

                                                            {/* {(data_v.enum == 'central_idea') &&
                                                                this.renderLessonCentralIdea()
                                                            } */}
                                                            {/* {(data_v.enum == 'central_idea') &&
                                                                this.renderLessonEvaluationTypes()
                                                            } */}

                                                        </div>
                                                    })}
                                                </div>
                                            </Tab>
                                            <Tab eventKey="lesson_resources" title="Resources">
                                                <div className='d-flex flex-column mt-2'>
                                                    {formSections.map((data_v, data_i) => {
                                                        // || data_v.sectionGroup.includes(sectionGroup)
                                                        if (!data_v.sectionGroup.includes(sectionGroup) || !['external_resource', 'Assessment_Information', 'exams', 'sub_lesson', 'activity'].includes(data_v.enum)) {
                                                            return null
                                                        }

                                                        return <div key={data_i} style={{ backgroundColor: White, borderRadius: 10 }} className=' mb-2'>
                                                            <div className='d-flex flex-row px-3 py-2' style={{ borderBottom: 'solid 1px ' + LightSilver, fontSize: 16 }}>{data_v.name}</div>
                                                            {/* DESC */}
                                                            <div className='d-flex flex-column'>
                                                                {data_v.desc && data_v.desc.map((vvv) => {
                                                                    return <div className='px-2 py-1' style={{ fontSize: 14, color: GraniteGray, fontStyle: 'italic' }}>{vvv}</div>
                                                                })}
                                                            </div>
                                                            {data_v.enum == 'external_resource' && this.renderExternalResources(data_v, data_i)}
                                                            {data_v.enum == 'Assessment_Information' && this.renderAssessmentInformation(data_v, data_i)}
                                                            {data_v.enum == 'activity' && <RenderActivities authData={authData} data_v={data_v} academic_activities={academic_activities} />}
                                                            {data_v.enum == 'sub_lesson' && <RenderSubLesson authData={authData} data_v={data_v} academic_subject_sub_lessons={academic_subject_sub_lessons} academic_subject_lesson_resources={academic_subject_lesson_resources} />}
                                                            {data_v.enum == 'exams' && <RenderExam authData={authData} data_v={data_v} academic_subject_lesson_exams={academic_subject_lesson_exams} />}

                                                        </div>
                                                    })}
                                                </div>
                                            </Tab>
                                        </Tabs>
                                        // FOR VIEW END
                                    }


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        )
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
})

export default connect(mapStateToProps, null)(withParams(LessonDetails))

class RenderActivities extends Component {
    state = {
    }
    componentDidMount() {
    }
    render() {
        const { data_v, academic_activities } = this.props
        return (<div className='d-flex flex-row flex-wrap p-3' style={{ fontSize: 12 }}>
            {academic_activities && academic_activities.map((v, i) => {
                return <div key={i} style={{ width: '20%', fontSize: 13 }} className={'pb-2 px-2'}>

                    <div className='d-flex flex-column p-2' style={{ borderRadius: 8, backgroundColor: Lotion, height: '100%' }}>
                        <div className='p-3 m-1' style={{ borderRadius: 8, backgroundColor: Cultured, border: 'solid 1px ' + AntiFlashWhite }}>
                            {(v.aa_image)
                                ? <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activities/' + v.aa_image} style={{ objectFit: 'cover', width: '100%', height: '100px', backgroundColor: White, borderRadius: '8px' }} />
                                : <img src={require('../../assets/images/noimage.png')} style={{ objectFit: 'cover', width: '100%', height: '100px', backgroundColor: White, borderRadius: '8px' }} />
                            }
                        </div>
                        <div className='d-flex flex-row'>
                            <div style={{ flex: 1, fontWeight: '600' }} className='d-flex flex-row flex-wrap'>{v.aa_name}</div>
                            <div className='px-1 cursor-pointer' onClick={() => {

                            }}>
                                <GetIcon icon="LuExternalLink" style={{ color: Blueberry }} />
                            </div>
                        </div>
                    </div>
                </div>
            })}
        </div>)
    }
}
class RenderSubLesson extends Component {
    state = {
        subLessonModal: {
            show: false,
            data: null,
            toggleModal: (data = null) => this.setState({ subLessonModal: { ...this.state.subLessonModal, show: !this.state.subLessonModal.show, data } })
        }
    }
    componentDidMount() {
    }

    renderSubLessonDetailsModal = () => {
        let { academic_subject_lesson_resources } = this.props
        let { subLessonModal } = this.state
        let data = subLessonModal.data
        return <Modal show={subLessonModal.show} backdrop='static' keyboard={false} onHide={() => {
            subLessonModal.toggleModal()
        }} size='xl'>
            {subLessonModal.show &&
                <Modal.Header closeButton>
                    <Modal.Title>{data.assl_name}</Modal.Title>
                </Modal.Header>
            }
            {subLessonModal.show &&
                <Modal.Body>
                    <Tabs defaultActiveKey='sub-lesson' id='fill-tab-example' className='mb-3'>
                        <Tab eventKey='sub-lesson' title={t('Sub Lesson')}>

                            <div className='d-flex flex-row'>
                                <div className='d-flex flex-column' style={{ flex: 1, fontSize: 13 }}>
                                    <div className='d-flex flex-column  p-2' style={{ backgroundColor: Lotion, borderRadius: 8, }}>
                                        <div style={{ width: '100%', height: 150 }} className='mb-2'>
                                            <img src={
                                                (data.assl_image)
                                                    ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_sub_lessons/' + data.assl_image
                                                    : require('../../assets/images/noimage.png')
                                            } style={{ height: '100%' }} />
                                        </div>
                                        <div className='mb-2'>
                                            {data.assl_name}
                                        </div>
                                        <div className={(data.assl_status) ? 'badge badge-light-success' : 'badge badge-light-danger'}>
                                            <GetIcon icon={(data.assl_status) ? 'LuCircleCheck' : 'LuCircleX'} className={'mb-1 me-1'} />
                                            {(data.assl_status) ? 'Active' : 'Disabled'}
                                        </div>
                                    </div>
                                </div>
                                <div className='ps-4 ms-4' style={{ flex: 2, borderLeft: 'solid 1px ' + ChineseWhite, fontSize: 13 }}>
                                    <div className='d-flex flex-row flex-wrap p-2' style={{ backgroundColor: Lotion, borderRadius: 8, height: '65vh', overflowY: 'auto' }}>
                                        {data.assl_usefulness &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Learning Objective')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_usefulness }} />
                                            </div>
                                        }
                                        {data.assl_preparation &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Instruction / Preparation')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_preparation }} />
                                            </div>

                                        }                                        {data.assl_warmup &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Tuning in / Warm up')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_warmup }} />
                                            </div>
                                        }
                                        {data.assl_steps &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Practice / Lesson Steps')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_steps }} />
                                            </div>
                                        }
                                        {data.assl_ending &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Wrap up / Exit')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_ending }} />
                                            </div>
                                        }
                                        {data.assl_differentiation &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Differentiated Activities')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_differentiation }} />
                                            </div>
                                        }
                                        {data.assl_objectives_description &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Learning Objectives')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_objectives_description }} />
                                            </div>
                                        }
                                        {data.assl_homeworks &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Main Activities')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_homeworks }} />
                                            </div>
                                        }
                                        {data.assl_technology &&
                                            <div style={{ width: '100%' }} className='px-2 py-1'>
                                                <div style={{ fontWeight: '600' }}>{t('Materials Needed')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: data.assl_technology }} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey='sub-lesson-resources' title='Resources'>
                            <div className='d-flex flex-row'>
                                {/* LISTING */}
                                <div className='' style={{ flex: 1 }}>
                                    <div style={{ height: '65vh', overflowY: 'auto' }}>
                                        <div className='d-flex flex-row flex-wrap p-2'>
                                            {academic_subject_lesson_resources.map((vvv, iii) => {
                                                if (vvv.aslr_type != 'external_resource_sub_lesson' || vvv.editing || !vvv.aslr_tags.includes('public')) {
                                                    return null
                                                }

                                                return <div key={iii} style={{ width: '25%' }} className='p-2'>
                                                    <div className="d-flex flex-column p-2 " style={{ backgroundColor: Lotion, borderRadius: 5, height: '100%', fontSize: 13 }}>
                                                        <div title={vvv.aslr_title}>{trimThisDown(vvv.aslr_title, 30)}</div>
                                                        <div className="d-flex flex-column my-2 align-items-center justify-content-center" style={{ backgroundColor: Cultured, borderRadius: 5, width: '100%', flex: 1 }}>

                                                            {(vvv.aslr_url_type && vvv.aslr_url_type != 'attachment') &&
                                                                <div className='d-flex flex-row justify-content-between align-items-center my-1'>
                                                                    <img src={require('../../assets/images/' + vvv.aslr_url_type + '.png')} style={{ width: 60 }} />
                                                                </div>
                                                            }

                                                            {!vvv.aslr_attachment &&
                                                                <div style={{ fontSize: 13, color: Black, textDecoration: 'underline' }} className='cursor-pointer' onClick={() => window.open(makeURL(vvv.aslr_url), vvv.aslr_title)}>
                                                                    {vvv.aslr_url}
                                                                </div>
                                                            }
                                                            {vvv.aslr_attachment && (!getExtension(vvv.aslr_attachment).includes('pdf')) && (
                                                                <div className='m-1'>
                                                                    <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lesson_resources/' + vvv.aslr_attachment} style={{ objectFit: 'cover', width: '100%', height: '6rem', backgroundColor: White, borderRadius: '1rem' }} />
                                                                </div>
                                                            )}
                                                            {vvv.aslr_attachment && (getExtension(vvv.aslr_attachment).includes('pdf')) && (
                                                                <div className='m-1'>
                                                                    <img src={require('../../assets/images/pdf.png')} style={{ objectFit: 'cover', width: '100%', height: '9.5rem', backgroundColor: White, borderRadius: '1rem' }} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Tab>
                    </Tabs>

                </Modal.Body>
            }
        </Modal>
    }


    render() {

        let { subLessonModal } = this.state
        const { data_v, academic_subject_sub_lessons } = this.props
        return (<div className='d-flex flex-row flex-wrap p-3' style={{ fontSize: 12 }}>
            {academic_subject_sub_lessons && academic_subject_sub_lessons.map((v, i) => {
                return <div key={i} style={{ width: '33.33%', fontSize: 13 }} className={'pb-2 px-2'}>

                    <div className='d-flex flex-row p-2' style={{ borderRadius: 8, backgroundColor: Lotion, height: '100%' }}>
                        <div className='p-3 m-1' style={{ borderRadius: 8, backgroundColor: Cultured, border: 'solid 1px ' + AntiFlashWhite }}>
                            {(v.assl_image)
                                ? <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_sub_lessons/' + v.assl_image} style={{ objectFit: 'cover', width: '100px', height: '100%', backgroundColor: White, borderRadius: '8px' }} />
                                : <img src={require('../../assets/images/noimage.png')} style={{ objectFit: 'cover', width: '100px', height: '100%', backgroundColor: White, borderRadius: '8px' }} />
                            }
                        </div>
                        <div className='d-flex flex-column ps-2' style={{ flex: 1 }}>
                            <div className='d-flex flex-row justify-content-between'>
                                <div style={{ flex: 1, fontWeight: '600' }} className='d-flex flex-row flex-wrap'>{v.assl_name}</div>
                                <div className='px-1 cursor-pointer' onClick={() => subLessonModal.toggleModal(v)}>
                                    <GetIcon icon="LuExternalLink" style={{ color: Blueberry }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            })}
            {this.renderSubLessonDetailsModal()}
        </div>)
    }
}

class RenderExam extends Component {
    state = {
    }
    componentDidMount() {
    }
    render() {
        const { data_v, academic_subject_lesson_exams } = this.props
        return (<div className='d-flex flex-row flex-wrap p-3' style={{ fontSize: 12 }}>
            {academic_subject_lesson_exams && academic_subject_lesson_exams.map((v, i) => {
                return <div key={i} style={{ width: '33.33%', fontSize: 13 }} className={'pb-2 px-2'}>

                    <div className='d-flex flex-row p-2' style={{ borderRadius: 8, backgroundColor: Lotion, height: '100%', overflow: 'hidden' }}>
                        <div className='p-3 m-1' style={{ borderRadius: 8, backgroundColor: Cultured, border: 'solid 1px ' + AntiFlashWhite }}>
                            {/* IMAGE COLUMN FOR EXAM DOES NOT EXIST */}
                            {(v?.asle_image)
                                ? <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_sub_lessons/' + v.asle_image} style={{ objectFit: 'cover', width: '100px', height: '100%', backgroundColor: White, borderRadius: '8px' }} />
                                : <img src={require('../../assets/images/noimage.png')} style={{ objectFit: 'cover', width: '100px', height: '100%', backgroundColor: White, borderRadius: '8px' }} />
                            }
                        </div>
                        <div className='d-flex flex-column ps-2' style={{ flex: 1 }}>
                            <div className='d-flex flex-row justify-content-between mb-2'>
                                <div style={{ flex: 1, fontWeight: '600' }} className='d-flex flex-row flex-wrap'>{v.asle_name}</div>
                                <div className='px-1 cursor-pointer' onClick={() => {

                                }}>
                                    <GetIcon icon="LuExternalLink" style={{ color: Blueberry }} />
                                </div>
                            </div>
                            <div className='d-flex flex-row flex-wrap mb-1'>
                                <div className='badge badge-light-info'>{(parseInt(v.asle_is_exampaper)) ? 'Online' : 'Recitation'}</div>
                            </div>
                            <div className='d-flex flex-row flex-wrap mb-1'>
                                <div style={{ fontWeight: '600' }} className='pe-1'>Type: </div>
                                {v.examstype_name}
                            </div>
                            <div className='d-flex flex-row flex-wrap mb-1'>
                                <div style={{ fontWeight: '600' }} className='pe-1'>Term: </div>
                                {v.term_d_name}
                            </div>
                            <div className='d-flex flex-row flex-wrap mb-1' style={{ whiteSpace: 'pre-line' }}>
                                <div style={{ fontWeight: '600' }} className='pe-1'>Description: </div>
                                {v.asle_description}
                            </div>
                        </div>
                    </div>
                </div>
            })}
        </div>)
    }
}